// extracted by mini-css-extract-plugin
export default {"main":"DocumentRow_main__m526n","name":"DocumentRow_name__mB6m-"};